import Vue from 'vue'
import Vuex from 'vuex'
import shared from './shared'
import employee from './employee'
import department from './department'
import report from './report'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    shared,
    employee,
    department,
    report
  }
})
